module.exports = __webpack_public_path__ + "media/3.3dcaf35d.wav";